import *  as axios from 'axios';
import * as R from 'ramda';
import * as PartnersActionTypes from '../../constants/actiontypes/backoffice/partners';

import * as partnersUrl from '../../constants/webapi/backoffice/partners';
import * as userUrls from '../../constants/webapi/user';
import { getAuthenticationUrl } from '../../constants/webapi/auth';
import { pageLimit } from '../../constants/paginations/paginationLimit';

export function GetPartners(pageNumber, searchTerm, sortByTerm, sortDesc) {

	const page = parseInt(pageNumber);
	if (!R.isNil(pageNumber) && isNaN(page)) {
		throw new Error("pageNumber must be null or an integer");
	}

	pageNumber -= 1;
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.FETCH_PARTNERS_REQUEST });
		return axios.get(partnersUrl.partnersUrl(pageNumber, searchTerm, sortByTerm, sortDesc))
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.FETCH_PARTNERS_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.FETCH_PARTNERS_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetPartnersDefaultState() {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.FETCH_PARTNERS_DEFAULT_REQUEST });
		return axios.get(partnersUrl.partnersUrlDefault())
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.FETCH_PARTNERS_DEFAULT_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.FETCH_PARTNERS_DEFAULT_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetPartnersDefault() {

	return new Promise((resolve, reject) => {
		axios.get(partnersUrl.partnersUrlDefault())
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				reject(error);
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				throw error;
			});
	});
}

export function GetPartner(partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.FETCH_PARTNER_REQUEST });
		return axios.get(partnersUrl.partnersByIdUrl(partnerId))
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.FETCH_PARTNER_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.FETCH_PARTNER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function CreatePartner(partnerDto) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.CREATE_PARTNER_REQUEST });
		return axios.post(partnersUrl.partnersUrlDefault(), partnerDto)
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.CREATE_PARTNER_SUCCESS,
					data: response.data
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.CREATE_PARTNER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function UpdatePartner(partnerDto) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.UPDATE_PARTNER_REQUEST });
		return axios.put(partnersUrl.partnersByIdUrl(partnerDto.id), partnerDto)
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.UPDATE_PARTNER_SUCCESS,
					//data: response.data,
					data: partnerDto,
					partnerId: partnerDto.id
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.UPDATE_PARTNER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function DeletePartner(partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.DELETE_PARTNER_REQUEST });
		return axios.delete(partnersUrl.partnersByIdUrl(partnerId))
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.DELETE_PARTNER_SUCCESS,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.DELETE_PARTNER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function UploadPartnerLogo(partnerId, logo) {
	const config = {
		headers: { 'content-type': 'multipart/form-data' },
		credential: 'include'
	};
	let data = new FormData();
	data.append("file", logo, logo.name);

	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.UPLOAD_LOGO_REQUEST, fileName: logo.name });
		return axios.post(partnersUrl.partnerLogoByIdUrl(partnerId), data, config)
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.UPLOAD_LOGO_SUCCESS,
					fileName: logo.name,
					partnerId: partnerId
				});
				return response;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.UPLOAD_LOGO_FAILURE,
					error: error.response,
				});
				throw error;
			});
	};
}

export function DownloadPartnerLogo(partnerId) {
	return axios.get(partnersUrl.partnerLogoByIdUrl(partnerId), { responseType: "arraybuffer" })
		.then((response) => {
			let blob = new Blob([response.data], { type: response.headers["content-type"] });
			if (!R.isNil(response.headers["content-disposition"])) {
				const fileName = response.headers["content-disposition"].split(";").find(p => p.trim().startsWith("filename="))?.replace("filename=", "");
				return new File([blob], fileName);
			} else {
				return new File([blob], "logo");
			}

		})
		.catch((error) => {
			throw error;
		});
}

export function GetEtablissementsByPartnerId(partnerId, pageNumber, searchTerm, status, sortByTerm, sortDesc) {
	pageNumber -= 1;
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.FETCH_ETABLISSEMENTS_REQUEST });
		return axios.get(partnersUrl.etablissementByPartnerIdUrl(partnerId, pageNumber, searchTerm, status, sortByTerm, sortDesc))
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.FETCH_ETABLISSEMENTS_SUCCESS,
					data: response.data,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.FETCH_ETABLISSEMENTS_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetEtablissementsByPartnerIdDefault(partnerId) {
	return axios.get(partnersUrl.etablissementByPartnerIdUrlDefault(partnerId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}

			throw error.statusText;
		});
}

export function CreateEtablissementsByPartnerId(etablissementDto, partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.CREATE_ETABLISSEMENT_REQUEST });
		return axios.post(partnersUrl.etablissementByPartnerIdUrlDefault(partnerId), etablissementDto)
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.CREATE_ETABLISSEMENT_SUCCESS,
					data: response.data,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.CREATE_ETABLISSEMENT_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function UpdateEtablissementsByPartnerId(etablissementDto, partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.UPDATE_ETABLISSEMENT_REQUEST });
		return axios.put(partnersUrl.etablissementByIdAndPartnerIdUrl(partnerId, etablissementDto.id), etablissementDto)
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.UPDATE_ETABLISSEMENT_SUCCESS,
					data: response.data,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.UPDATE_ETABLISSEMENT_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function DeleteEtablissementsByPartnerId(etablissementId, partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.DELETE_ETABLISSEMENT_REQUEST });
		return axios.delete(partnersUrl.etablissementByIdAndPartnerIdUrl(partnerId, etablissementId))
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.DELETE_ETABLISSEMENT_SUCCESS,
					etablissementId: etablissementId,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.DELETE_ETABLISSEMENT_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GenerateApiKey(partnerId, etablissementId) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.GENERATE_ETABLISSEMENT_API_KEY_REQUEST, partnerId, etablissementId });
		return axios.post(partnersUrl.generateApiKeyUrl(partnerId, etablissementId))
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.GENERATE_ETABLISSEMENT_API_KEY_SUCCESS,
					partnerId,
					etablissementId,
					data: response.data
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.GENERATE_ETABLISSEMENT_API_KEY_FAILURE,
					error: error.response,
					partnerId,
					etablissementId
				});
				throw error;
			});
	};
}

export function GetUsersByPartnerId(partnerId, pageNumber, searchTerm, role, status, sortByTerm, sortDesc) {
	const page = parseInt(pageNumber);
	if (!R.isNil(pageNumber) && page === NaN) {
		throw "pageNumber must be null or an integer";
	}
	pageNumber -= 1;

	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.FETCH_USERS_REQUEST });
		return axios.get(partnersUrl.usersByPartnerIdUrl(partnerId) + `?${role !== "" ? 'roles=' + role : "roles=PARTNER,ETABLISSEMENT"}&pagesize=${pageLimit}&pageNumber=${pageNumber}${searchTerm !== "" ? '&textSearch=' + searchTerm : ""}${role !== "" ? '&roles=' + role : ""}${status !== "" ? '&status=' + status : ""}${sortByTerm !== "" ? '&sortBy=' + sortByTerm : ""}${sortDesc === "true" ? '&sortDesc=true' : '&sortDesc=false'}`)
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.FETCH_USERS_SUCCESS,
					data: response.data,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.FETCH_USERS_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function GetUsersByPartnerIdDefault(partnerId) {
	return axios.get(partnersUrl.usersByPartnerIdUrl(partnerId) + `?roles=PARTNER,ETABLISSEMENT`)
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}

			throw error;
		});

}


export function getUserRepresentatives(userId) {
	return new Promise((resolve, reject) => {
		axios.get(userUrls.userRepresentativesUrlById(userId))
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				reject(error);
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}

				throw error.statusText;
			});
	});
}

export function CreateUserByPartnerId(userDto, partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.CREATE_USER_REQUEST });
		return axios.post(partnersUrl.usersByPartnerIdUrl(partnerId, R.isNil(userDto.etablissementId) ? "PARTNER" : "ETABLISSEMENT"), userDto)
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.CREATE_USER_SUCCESS,
					data: response.data,
					partnerId: partnerId
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.CREATE_USER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function UpdateUserByPartnerId(userDto, partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.UPDATE_USERPARTNER_REQUEST });
		return axios.put(partnersUrl.userByIdPartnerIdUrl(partnerId, userDto.id, R.isNil(userDto.etablissementId) ? "PARTNER" : "ETABLISSEMENT"), userDto)
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.UPDATE_USERPARTNER_SUCCESS,
					data: response.data,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.UPDATE_USERPARTNER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function DeleteUserByPartnerId(userId, partnerId) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.DELETE_USER_REQUEST });
		return axios.delete(partnersUrl.userByIdUrl(userId))
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.DELETE_USER_SUCCESS,
					userId: userId,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.DELETE_USER_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function SendUserActivationEmailByPartnerId(userId, partnerId, role) {
	return (dispatch) => {
		dispatch({ type: PartnersActionTypes.SEND_USER_ACTIVATION_REQUEST });
		return axios.put(partnersUrl.userSendActivationEmailByIdPartnerIdUrl(partnerId, userId, role))
			.then((response) => {
				dispatch({
					type: PartnersActionTypes.SEND_USER_ACTIVATION_SUCCESS,
					userId: userId,
					partnerId: partnerId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: PartnersActionTypes.SEND_USER_ACTIVATION_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function downloadReport(partnerId, fromDate, toDate) {
	return axios.get(partnersUrl.downloadReport(partnerId, fromDate, toDate), { responseType: "arraybuffer" })
		.then((response) => {
			var file = new Blob([response.data], { type: response.headers["content-type"] });
			var fileurl = window.URL.createObjectURL(file);
			const a = document.createElement('a');
			a.style.display = 'none';
			a.href = fileurl;
			// the filename you want
			a.download = R.isNil(response.headers["content-disposition"]) ? "file.csv" : response.headers["content-disposition"].split(";").find(s => s.trim().startsWith("filename=")).replace(" filename=", "");
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(file);
			//var fileurl = window.URL.createObjectURL(file);
			//window.open(fileurl);
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
}


